import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2 } from 'lucide-react';
import { Button } from './Button';
export function SolutionSection() {
  const benefits = ['Sin exámenes médicos', 'Aprobación en menos de 10 minutos', 'Primas bajas desde $1 al día', 'Pago directo a tu familia cuando más lo necesita', 'Cobertura desde $5,000 hasta $25,000 dólares'];
  return <section className="py-[50px] md:py-[80px] px-6 bg-brand-darkGray border-y border-brand-gold/20 relative" data-id="element-149">
      <div className="max-w-[900px] mx-auto" data-id="element-150">
        {/* Top Image */}
        <FadeIn data-id="element-151">
          <div className="w-full max-w-2xl mx-auto h-64 md:h-80 rounded-3xl overflow-hidden mb-12 border-2 border-brand-gold/30 shadow-[0_0_30px_rgba(245,166,35,0.15)]" data-id="element-152">
            <img src="https://images.unsplash.com/photo-1454418747937-bd95bb945625?w=800&q=80" alt="Manos protectoras sosteniendo las de una persona mayor" className="w-full h-full object-cover object-center" data-id="element-153" />
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-154">
          <div className="text-center mb-12" data-id="element-155">
            <h2 className="text-[32px] md:text-[38px] font-bold text-brand-gold mb-8 leading-tight" data-id="element-156">
              Existe Una Solución Simple, <br className="hidden md:block" data-id="element-157" />
              Rápida y Sin Complicaciones
            </h2>
            <div className="text-[20px] text-white space-y-2" data-id="element-158">
              <p data-id="element-159">Se llama Final Expense.</p>
              <p data-id="element-160">
                Una póliza diseñada especialmente para personas como tú, de 50 a
                85 años.
              </p>
              <p className="pt-4" data-id="element-161">Y funciona así de simple:</p>
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-162">
          <div className="bg-brand-black border border-white/10 rounded-3xl p-8 md:p-12 shadow-2xl max-w-3xl mx-auto mb-12" data-id="element-163">
            <ul className="space-y-6" data-id="element-164">
              {benefits.map((benefit, index) => <li key={index} className="flex items-start gap-4" data-id="element-165">
                  <CheckCircle2 className="w-8 h-8 text-brand-green shrink-0 mt-1" data-id="element-166" />
                  <span className="text-[20px] text-white leading-tight" data-id="element-167">
                    {benefit}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="text-center" data-id="element-168">
            <Button onClick={() => document.getElementById('formulario')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-169">
              QUIERO PROTEGER A MI FAMILIA HOY
            </Button>
          </div>
        </FadeIn>
      </div>
    </section>;
}